import React, { useEffect, useState } from "react";
import { getSharedPublic } from "@/lib/api";
import { useLocale } from "@/context/LocaleContext";

export default function AnnouncementBar() {
  const { t, locale } = useLocale();
  const [text, setText] = useState(null);

  useEffect(() => {
    let active = true;
    getSharedPublic("/content/general_settings").then((res) => {
      if (active && res.data?.data?.announcement_text) setText(res.data.data.announcement_text);
    }).catch(() => {});
    return () => { active = false; };
  }, []);

  // The announcement is admin-editable free text (French only for now); in EN/DE we show the
  // translated default copy unless the admin text is the default one being overridden live.
  const displayText = locale === "fr" ? (text || t("announcement.default")) : t("announcement.default");

  return (
    <div
      data-testid="announcement-bar"
      className="min-h-9 bg-levami-ivoire text-levami-brun text-[10px] leading-tight sm:text-xs tracking-label flex items-center justify-center border-b border-levami-sable px-3 sm:px-4 py-1.5 text-center"
    >
      <p className="max-w-5xl text-balance sm:whitespace-nowrap">{displayText}</p>
    </div>
  );
}
